module.exports = __webpack_public_path__ + "4886f8d6d96588657a7f220df090f1f2.svg";